<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">
    <!-- <img class="background-img col-12 cover h100" src="../assets/cls_sideview.png"> -->


    <!-- Headerbar Start -->

    <cql-headerbar/>

    <!-- Headerbar End -->

    <select-creator-profile-lightbox style="z-index: 99999" :exportFromCalcCard="true" :calculationid="pdfExportCalcId"/>



    <div class="lightbox" v-show="showDeletionPopupModal">
        <div class="lightbox-box flex-column bg-color-darkgray p3 rounded-border max-width-4 mt4">
            <button class="lightbox-close-btn" @click="showDeletionPopupModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 class="h3 white regular center mb4">{{$t('calc-overview_deletion_popup_wirklich_loeschen_part_1')}}{{calcToBeDeletedName}}{{$t('calc-overview_deletion_popup_wirklich_loeschen_part_2')}}</h2>
            <div class="flex align-middle justify-center">
              <div>
                <a class="btn btn-small btn-bg-red mr3" @click="showDeletionPopupModal = false, calcToBeDeleted = '', calcToBeDeletedName = '' ">{{$t('calc-overview_deletion_popup_decline')}}</a>
              </div>
              <div>
                <a class="btn btn-small" @click="deleteCalc()">{{$t('calc-overview_deletion_popup_accept')}}</a>
              </div>
            </div>
        </div>
    </div>

    <!-- EDITING EXISTING CALC -->
    <div class="lightbox" v-if="openCalcEditModal">
        <div class="lightbox-box flex-column bg-color-darkgray p3 rounded-border max-width-3 mt4 ui-modal--settings col-12">
            <button class="lightbox-close-btn" @click="openCalcEditModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 class="h3 white regular center mb4">{{$t('calcs-overview_edit_modal_calc_heading')}}</h2>
            <div class=" row-sys flex align-middle col-12 mb1">
              <p class="col-3 small white  ">{{$t('calcs-overview_edit_modal_calc_name')}}</p>
              <input class="user-input-narrow col-8 border-box" :placeholder="$t('calcs-overview_edit_modal_calc_name_placeholder')" v-model="editCalcTitle">
            </div>
            <div class=" row-sys flex col-12 mb1">
              <p class="col-3 small white  ">{{$t('calcs-overview_edit_modal_description')}}</p>
              <div class="col-8 border-box">
                <textarea rows=4 class="user-input-narrow border-box col-12" maxlength="1000" :placeholder="$t('calcs-overview_edit_modal_description_placeholder')" v-model="editCalcDescription" />
                <p class="color-gray text-right mb2">{{descStrLength}} / 1000</p>
              </div>
            </div>
            <div class="flex justify-end col-11">
            <a class="btn btn-small self-end" @click="editObj()">{{$t('calcs-overview_edit_modal_btn_ok')}}</a>
            </div>
        </div>
    </div>

    <div class="px4">
      <!-- <div class="ui-navbar flex align-middle ml2 mb3">
        <router-link class="house-button pointer" :to="'/' + this.$i18n.locale + '/projects'">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 8.4V3.5C20.5 3.22385 20.2761 3 20 3H18C17.7239 3 17.5 3.22385 17.5 3.5V5.64L13.338 1.811C13.1465 1.63437 12.8515 1.63437 12.66 1.811L1.66001 12.132C1.50816 12.2717 1.45769 12.4903 1.53294 12.6824C1.60818 12.8745 1.79369 13.0006 2.00001 13H4.50001V22.5C4.50001 23.0523 4.94772 23.5 5.50001 23.5H20.5C21.0523 23.5 21.5 23.0523 21.5 22.5V13H24C24.2061 13.0002 24.3913 12.8739 24.4663 12.6819C24.5412 12.4899 24.4907 12.2715 24.339 12.132L20.5 8.4Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
        <h1 class="h0 regular white ml2">{{$t('calc-overview_h_berechnung')}}</h1>
      </div> -->
      <div class="ui-navbar flex align-middle ml2 mb3 mt2 justify-between">
        <div class="flex align-middle">        
          <router-link class="house-button pointer" :to="'/' + this.$i18n.locale + '/projects'">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 8.4V3.5C20.5 3.22385 20.2761 3 20 3H18C17.7239 3 17.5 3.22385 17.5 3.5V5.64L13.338 1.811C13.1465 1.63437 12.8515 1.63437 12.66 1.811L1.66001 12.132C1.50816 12.2717 1.45769 12.4903 1.53294 12.6824C1.60818 12.8745 1.79369 13.0006 2.00001 13H4.50001V22.5C4.50001 23.0523 4.94772 23.5 5.50001 23.5H20.5C21.0523 23.5 21.5 23.0523 21.5 22.5V13H24C24.2061 13.0002 24.3913 12.8739 24.4663 12.6819C24.5412 12.4899 24.4907 12.2715 24.339 12.132L20.5 8.4Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
          <div class="flex align-middle">
            <div class="ml3">
              <h3 class="caps p-tiny narrow color-gray regular">{{$t('calcs-overview_nav_project')}}</h3>
              <router-link class="white h3 regular m0"  :to="'/' + this.$i18n.locale + '/calculations/' + project.id">{{project.title | truncate(30, '...')}}</router-link>
            </div>
            <svg class="px3" width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(-90deg);">
                <path d="M16.3105 1.56042L9.87155 8.00042C9.2858 8.586 8.3363 8.586 7.75055 8.00042L1.31055 1.56042" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="h3 regular white">{{$t('calcs-overview_nav_calculations')}}</p>
          </div>
        </div>
        <div class="flex px4 border-box">
          <div class="flex align-middle pointer" @click="createNewObj()">
            <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
              <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="white p-small ml1 mr4" @click="createNewObj()">{{$t('calc-overview_p_neue_berechnung')}}</p>
          </div>
          <!-- <div class="flex align-middle pointer">
            <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
              <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.247 5.25H21.747C22.5755 5.25 23.247 5.92157 23.247 6.75V21.75C23.247 22.5784 22.5755 23.25 21.747 23.25H8.24704C7.41861 23.25 6.74704 22.5784 6.74704 21.75V15.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.747 9.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.497 14.25H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5 18.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25004 9.75V6.75L12.439 2.561C12.7423 2.25756 12.833 1.80138 12.6688 1.40504C12.5047 1.0087 12.118 0.750194 11.689 0.75H1.81104C1.38205 0.750194 0.995395 1.0087 0.831256 1.40504C0.667117 1.80138 0.757798 2.25756 1.06104 2.561L5.25004 6.75V12.75L8.25004 9.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="white p-small ml1">{{$t('calc-overview_p_filter')}}</p>
          </div> -->
        </div>
      </div>
      <div class="flex flex-wrap max-width-7 op0" style=" transition: opacity .3s ease .3s;" :class="{op100: calcs.length !== 0, absolute: calcs.length !== 0}">
        <calc-card 
          v-for="calc in calcs" 
          :key="calc.id"
          :id="calc.id"
          :title="calc.title"
          :subtitle="calc.description"
          :lastChanged="calc.lastChanged"
          :session="session"
        />
      </div>
      <div class="ml2 pt4 op0 absolute" style="transition: opacity .3s ease .3s;" :class="{op100: fetchedCalcs == true && calcs.length == 0, npe: fetchedCalcs == true && calcs.length !== 0 }">
        <h2 class="h1 light white mb2">{{$t('calc-overview_h_keine_berechnung_vorhanden')}}</h2>
        <button class="btn btn-primary" v-on:click="createNewObj()">{{$t('calc-overview_btn_neue_berechnung_erstellen')}}</button>
      </div>

      <div class="synchronising-box bg-color-darkgray px4 py3 max-width-1 mx-auto flex flex-column justify-center drop-shadow rounded-border" :class="{hidden: fetchedCalcs == true}" style="z-index: 9999;">
        <div class="flex justify-center mb3">
        <img src="../assets/cql_logo.svg" style="width: 100px;">
        </div>
        <div class="mx-auto mt3 mb3 spinning relative">
          <svg class="synchro-arrows" width="70" height="70" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.7496 19.9889L28.8755 14.5788L25.0479 20.773" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M28.8505 14.6473C30.8379 22.2118 26.3273 29.9576 18.7673 31.9624" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.64827 1L5.92969 7.75154L13.1731 8.47289" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.94922 7.73741C11.8941 2.63272 20.8455 3.28748 25.9843 9.2029" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.43481 33L10.6383 31.9465L7.60463 25.3261" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5395 31.8865C3.15258 29.3364 -0.770083 21.2824 1.77646 13.8943" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h4 class="h4 regular white center mt3">{{$t('calc-overview_h_synchronisiere')}}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import cqlHeaderbar from './cqlHeaderbar.vue';
import CalcCard from './CalcCard.vue';
import selectCreatorProfile from './selectCreatorProfile.vue';


import { EventBus } from "../event-bus";
import axios from 'axios'

export default {
  name: "CalcsOverview",
  data() {
    return {
    // Test for Doubelinit
    openCalcEditModal: false,
    editCalcTitle: '',
    editCalcDescription: '',
    editCalcId: '',

    pdfExportCalcId: '',


    iveBeenInitated: false,
    componentLoaded: false,
    createNewModal: false,
    showDeletionPopupModal: false,
    calcToBeDeleted: '',
    calcToBeDeletedName: '',
    modalData: {
      name: '',
      deckendicke: '',
      ausfuehrung: 0,
      norm: 0,
      erforderlich: '',
      erforderlich_select: 0,
      brandschutzklasse: 0,
      system: 0,
      hoehe: '',

    },
    createNew: false,
    newTitle: '',
    newSubtitle: '',
    newDate: new Date(),
    job: {},
    project: {},
    fetchedCalcs: null,
      calcs: [
        
      ],
    };
  },


  created: function () {
  EventBus.$on('loginSuccessful', (payload) => {
      
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      // console.log('CalculationsOverview.vue recieved Event: "loginSuccessful"!');
      if(!this.componentLoaded) {
        this.userdata = payload.userdata;
        this.username = payload.userdata.company  + " " + payload.userdata.firstname + " " + payload.userdata.name;
        this.session = payload.session;
        this.loginStatus = true;

        this.loadCalculationList();
        this.loadJobHead();
        this.componentLoaded = true;
      }
    });

    //console.log('Event-Bus-Emitting started in CalcsOverview!' + this.iveBeenInitated);
    this.iveBeenInitated = true;
    EventBus.$on('cloneCalculation', (payload) => {
      //console.log('EvtentBus received: clone calc')
      this.fetchedCalcs = false;
      
      let currentObj = this;
      let data = {calculationid: payload.id};
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-actions/clone/json', merged)
        .then(function () {
          //console.log(response);
          setTimeout( function () {
            currentObj.loadCalculationList();
          },500);
          
        });
    });
    EventBus.$on('removeCalcPopup', (payload) => {
      //console.log(payload)
      this.showDeletionPopupModal = true;
      this.calcToBeDeleted = payload.id;
      this.calcToBeDeletedName = payload.name;
    })

    EventBus.$on('loginNotCorrect', () => {
      this.$router.push({ path:'/'});
    });
    EventBus.$on('editCalcSettings', (payload) => {
      this.openCalcEditModal = true
      this.editCalcTitle = payload.title
      this.editCalcDescription = payload.subtitle
      this.editCalcId = payload.id
    });
    EventBus.$on('prepare_pdf_report', (payload) => {
      this.pdfExportCalcId = payload.id;
      EventBus.$emit('open_creatorProfileSelectionModal');
    })
 }, 
  mounted: function () {
    //console.log('CalcsOverview.vue: emitting Event: loginCheckQaL');
    EventBus.$emit('loginCheckQaL', {

    });
  },	
  beforeDestroy () {
    EventBus.$off('cloneCalculation');
    EventBus.$off('removeCalculation');
    //EventBus.$off('loginSuccessful');
    //EventBus.$off('loginSuccessfulSubComponents');
  },
  methods: {
    loadJobHead() {
      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-actions/load/json';

      let currentObj = this;
      let data = {};
      data.projectid = this.$route.params.projectsid;

      let merged = {...data, ...this.session};

      axios.post(url, merged)
        .then(response => {
          //console.log(response.data);
         //currentObj.job = response.data.job;
         currentObj.project = response.data;
         
      }).catch(function () { console.log('catch Function of AJAX-Called... error()');  });
    },
    editObj(){
      let currentObj = this;
      let data = {};
      //console.log(data)
      data.name = this.editCalcTitle;
      data.description = this.editCalcDescription;
      data.calculationid = this.editCalcId;
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-actions/update/json', merged).then(function () {
        
        currentObj.loadCalculationList(); currentObj.openCalcEditModal = false;
        
        }  );
    },
    loadCalculationList() {
      this.fetchedCalcs = false;
      //console.log('loadProjectsList.called()');
      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-list/json';
      //let currentObj = this;

      let data = {};
      data.projectsid = this.$route.params.projectsid;

      let merged = {...data, ...this.session};
      axios.post(url, merged)
      .then(response => {
        this.calcs = response.data.calculations;
        this.fetchedCalcs = true;
      })
      .catch(function () {
        this.log('catch Function of AJAX-Called... error()');
      });

    },
    createNewObj(){
          this.createNewModal = false;
          //this.calcs.push({id: this.calcs.length + 1, title: this.modalData.name, subtitle: this.modalData.subtitle, lastChanged: this.newDate})
          this.fetchedCalcs = true;
          /*
            /calculation-actions/add/json
          */

          let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-actions/add/json';

          let data = {};
          data.projectsid = this.$route.params.projectsid;
          data.name = this.modalData.name;
          data.description = this.modalData.subtitle;

          let merged = {...data, ...this.session};
          axios.post(url, merged)
          .then(response => {
          //   console.log('calc create resp:');
          //  console.log(response.data);

            this.$router.push({ path: '/' + this.$i18n.locale + '/calculation/' + response.data.calc_id});
          })
          .catch(function () {
            console.log('catch Function of AJAX-Called... error()');
          });
      },
    newProjectModal() {
      this.createNewModal = true;
    },
    deleteCalc(){
      //console.log('Calculation Deletion Function called')
      let currentObj = this;
      let data = {calculationid: this.calcToBeDeleted};
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-actions/remove/json', merged)
        .then(currentObj.loadCalculationList());
      this.showDeletionPopupModal = false;
      this.calcToBeDeleted = '';
    }
  },
  computed: {
    descStrLength(){
      if(this.editCalcDescription !== null){
      return this.editCalcDescription.length;
      }
      else return 0;
    }
  },

  components: {
    'calc-card': CalcCard,
    'cql-headerbar':cqlHeaderbar,
    'select-creator-profile-lightbox': selectCreatorProfile,
  },

};
</script>
<style scoped>
</style>